/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'

type props = {
  id: any
  subject: any
  status: any
  ticketReplies: any
  account: any
}

const statusTextMapping: any = {
  0: {
    text: 'Açık',
    type: 'success',
  },
  1: {
    text: 'Cevap Bekliyor',
    type: 'warning',
  },
  2: {
    text: 'Cevaplandı',
    type: 'primary',
  },
  3: {
    text: 'Kapatıldı',
    type: 'success',
  },
}

const TicketDrawerItem: FC<props> = (props) => {
  return (
    <div className='d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3 mb-5'>
      <span className='fs-5 text-dark text-hover-primary fw-bold w-100px'>#{props.id}</span>
      <span className='fs-5 w-300px min-w-200px'>{props.subject}</span>
      <div className='min-w-175px'>
        <span className='badge badge-light text-muted'>Fleksup Destek Ekibi</span>
      </div>
      <div className='symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px'>
        <div className='symbol symbol-circle symbol-25px'>
          <div
            className={`symbol-label fs-8 fw-bold bg-${
              statusTextMapping[props.status].type
            } text-inverse-primary`}
          >
            {props.account?.companyUser?.first_Name && props.account?.companyUser?.first_Name[0]}
          </div>
        </div>
        {props.ticketReplies &&
          props.ticketReplies.filter((item: any) => item.answeredBy === -1)?.length > 0 && (
            <div className='symbol symbol-circle symbol-25px'>
              <div
                className={`symbol-label fs-8 fw-bold bg-${
                  statusTextMapping[props.status].type
                } text-inverse-primary`}
              >
                F
              </div>
            </div>
          )}
      </div>
      <div className='min-w-125px'>
        <span className={`badge badge-light-${statusTextMapping[props.status].type}`}>
          {statusTextMapping[props.status].text}
        </span>
      </div>
      <Link to={`/tickets/${props.id}`} className='btn btn-sm btn-light btn-active-light-primary'>
        Detay
      </Link>
    </div>
  )
}

export {TicketDrawerItem}
